import { initLegal } from '@adornis/legal/init.js';

/** Employment here follows German law. */
export const legal = initLegal('DE');
